<template>
	<div class="iCard">
		<search-i-card
			v-on:addICard="addICard"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			v-on:importSuccess="importSuccess"
			:search="search"
		>
		</search-i-card>
		<add-i-card
			:userList="userList"
			:levelList="levelList"
			:receiveTypeList="receiveTypeList"
			:iCard="iCard"
			:defaultdate="defaultdate"
			v-on:cancel="cancel"
			:dialogICard="dialogICard"
		>
		</add-i-card>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="cardList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userName"
					:label="$t('iCard.userName')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="cardNo"
					:label="$t('iCard.cardNo')"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="cardName"
					:label="$t('iCard.cardName')"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="level"
					:label="$t('iCard.level')"
					:formatter="level"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="useMode"
					:label="$t('iCard.useMode')"
					:formatter="level"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="receiveType"
					:label="$t('iCard.receiveType')"
					width="130"
					:align="'center'"
					:formatter="receiveType"
				></el-table-column>
				<el-table-column
					prop="availableNum"
					:label="$t('iCard.availableNum')"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="last"
					:label="$t('iCard.last')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="used"
					:label="$t('iCard.used')"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="amount"
					:label="$t('iCard.amount')"
					width="100"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="notes"
					:show-overflow-tooltip="true"
					:label="$t('iCard.notes')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('iCard.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 210 : 224"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['sys:card:update']"
							@click="editICard(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							size="mini"
							type="warning"
							v-hasPerm="['sys:card:reset']"
							@click="resetICard(scope.row)"
							>{{ $t("common.reset") }}</el-button
						>
						<el-button
							type="danger"
							v-hasPerm="['sys:card:delete']"
							size="mini"
							@click="delICard(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchICard from "_c/system/ic/SearchICard";
import addICard from "_c/system/ic/AddICard";
export default {
	name: "ICard",
	components: {
		searchICard,
		addICard,
	},
	data() {
		return {
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				userName: "",
				cardNo: "",
				cardName: "",
				startTime: "",
				endDate: "",
			},
			loading: false,
			cardList: [],
			dialogICard: false,
			iCard: {
				id: "",
				cardNo: "",
				cardName: "",
				startTime: "",
				endDate: "",
				level: "0",
				availableNum: 1,
				receiveType: "1",
				notes: "",
				uId: "",
				userName: this.$cookies.get("nickName"),
			},
			levelList: [],
			userList: [
				{
					id: this.$cookies.get("uid"),
					nickName: this.$cookies.get("nickName"),
					userName: this.$cookies.get("userName"),
				},
			],
			receiveTypeList: [],
			defaultdate: [],
		};
	},
	mounted() {
		this.currentChange();
		this.listLevelList();
		this.listReceiveType();
	},
	methods: {
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.ICard.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.cardList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		listLevelList() {
			this.$api.dict("gp_card_level").then(res => {
				if (res.code === 0) {
					this.levelList = res.data;
				}
			});
		},
		listReceiveType() {
			this.$api.dict("gp_receive_type").then(res => {
				if (res.code === 0) {
					this.receiveTypeList = res.data;
				}
			});
		},
		addICard() {
			this.dialogICard = true;
			this.iCard.level = "0";
			this.iCard.last = 1;
			this.defaultdate = [new Date(), new Date()];
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		editICard(row) {
			let _self = this;
			this.dialogICard = true;
			let dateSet = [];
			Object.keys(_self.iCard).forEach(key => {
				if (key == "startTime" && row[key]) {
					dateSet[0] = row[key];
				} else if (key == "endDate" && row[key]) {
					dateSet[1] = row[key];
				}
				this.iCard[key] = row[key];
			});
			this.defaultdate = [];
			if (_self.iCard["startTime"] && _self.iCard["endDate"]) {
				let startTime = _self.iCard["startTime"];
				let startYear = new Date(startTime).getFullYear();
				let startMonth = new Date(startTime).getMonth();
				startMonth = parseInt(startMonth);
				let startDate = new Date(startTime).getDate();
				startDate = parseInt(startDate);
				let startHours = new Date(startTime).getHours();
				startHours = parseInt(startHours);
				let startMinutes = new Date(startTime).getMinutes();
				startMinutes = parseInt(startMinutes);
				let startSeconds = new Date(startTime).getSeconds();
				startSeconds = parseInt(startSeconds);
				startTime =
					startYear +
					"-" +
					startMonth +
					"-" +
					startDate +
					" " +
					startHours +
					":" +
					startMinutes +
					":" +
					startSeconds;
				let endTime = _self.iCard["endDate"];
				let endYear = new Date(endTime).getFullYear();
				let endMonth = new Date(endTime).getMonth();
				endMonth = parseInt(endMonth);
				let endDate = new Date(endTime).getDate();
				endDate = parseInt(endDate);
				let endHours = new Date(endTime).getHours();
				endHours = parseInt(endHours);
				let endMinutes = new Date(endTime).getMinutes();
				endMinutes = parseInt(endMinutes);
				let endSeconds = new Date(endTime).getSeconds();
				endSeconds = parseInt(endSeconds);
				endTime =
					endYear +
					"-" +
					endMonth +
					"-" +
					endDate +
					" " +
					endHours +
					":" +
					endMinutes +
					":" +
					endSeconds;
				this.defaultdate = [
					new Date(
						startYear,
						startMonth,
						startDate,
						startHours,
						startMinutes,
						startSeconds
					),
					new Date(
						endYear,
						endMonth,
						endDate,
						endHours,
						endMinutes,
						endSeconds
					),
				];
			}
		},
		resetICard(row) {
			this.$confirm(this.$t("iCard.reset"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ICard.reset, this.$method.put, { id: row.id })
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},
		delICard(row) {
			this.$confirm(this.$t("iCard.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ICard.delete, this.$method.delete, { id: row.id })
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},
		cancel(dialog, state) {
			this.dialogICard = dialog;
			if (state) {
				this.currentChange();
			}
		},
		level(row) {
			return this.$cloud.getDictLabel(this.levelList, row.level);
		},
		receiveType(row) {
			return this.$cloud.getDictLabel(this.receiveTypeList, row.receiveType);
		},
		importSuccess(result) {
			if (result.success > 0) {
				this.currentChange();
			}
		},
	},
};
</script>

<style lang="scss"></style>
